import React from "react";

interface Props {
  data: any;
}

const SymptomsCard: React.FC<Props> = ({ data }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow mb-6">
      <h2 className="font-bold text-xl mb-2">
        For - {data?.patient?.name}
      </h2>
      <p className="text-sm">
        {data?.symptoms?.length ? data.symptoms.join(", ") : "No symptoms provided"}
      </p>
    </div>
  );
};

export default SymptomsCard;
